import { httpClient } from '../core/http';

export type CanvasSessionStatePayload = {
  crew_id: number;
  session_id: string;
  payload: Record<string, unknown>;
  tool_type?: string;
};

/**
 * Persiste estado do canvas (campos do iframe / template) para o mesmo session_id do execute-ai.
 * O backend injeta isto no contexto da próxima execução (CANVAS_DADOS_PERSISTIDOS).
 */
export async function putExecuteAiCanvasSessionState(
  body: CanvasSessionStatePayload
): Promise<void> {
  await httpClient.put('/v1/execute-ai/canvas-session-state', body);
}
